import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { NTA_COLORS } from '../constants';

const Control = styled.span`
  width: 10px;
  height: 10px;
  flex-shrink: 0;
  box-sizing: border-box;
  border: 1px solid ${NTA_COLORS.optionControlBorder};
  background: ${NTA_COLORS.optionControlBg};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: ${({ $type }) => ($type === 'radio' ? '50%' : '1px')};
`;

const RadioDot = styled.span`
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: ${NTA_COLORS.optionControlMark};
  opacity: ${({ $checked }) => ($checked ? 1 : 0)};
`;

const CheckMark = styled.span`
  width: 6px;
  height: 3px;
  border-left: 2px solid ${NTA_COLORS.optionControlMark};
  border-bottom: 2px solid ${NTA_COLORS.optionControlMark};
  transform: rotate(-45deg) translateY(-1px);
  opacity: ${({ $checked }) => ($checked ? 1 : 0)};
`;

const NtaOptionControl = ({ type, checked }) => (
  <Control $type={type} $checked={checked} aria-hidden>
    {type === 'radio' ? (
      <RadioDot $checked={checked} />
    ) : (
      <CheckMark $checked={checked} />
    )}
  </Control>
);

NtaOptionControl.propTypes = {
  type: PropTypes.oneOf(['radio', 'checkbox']).isRequired,
  checked: PropTypes.bool.isRequired
};

export default NtaOptionControl;
